import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Para qué edad es el kit?',
    a: 'El kit está diseñado específicamente por especialistas para niños y niñas en la etapa de 1 a 3 años, adaptándose a sus diferentes ritmos de aprendizaje y desarrollo cognitivo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu compra, recibirás un enlace de acceso a Google Drive donde podrás descargar todo el material en formato PDF.'
  }, {
    q: '¿Puedo imprimirlo?',
    a: 'Sí, todo el material está diseñado en alta calidad para ser impreso desde cualquier impresora hogareña.'
  }, {
    q: '¿Necesito materiales especiales para las actividades?',
    a: 'No, las actividades están pensadas para realizarse con materiales simples que tenés en casa: crayones, tijeras, pegamento, etc.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, tenés 7 días de garantía. Si no estás conforme, te devolvemos el 100% de tu dinero sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 md:py-14 px-4 bg-[#f5f9ff]" data-id="element-91">
      <div className="max-w-3xl mx-auto" data-id="element-92">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-center text-gray-900 mb-8" data-id="element-93">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-94">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-gray-200 rounded-xl overflow-hidden transition-colors hover:border-blue-300" data-id="element-95">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-96">
                <span className="font-bold text-base md:text-lg text-gray-900 pr-4" data-id="element-97">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-blue-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-98" />
              </button>

              <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 py-4 border-t-2 border-gray-100' : 'max-h-0 py-0'}`} data-id="element-99">
                <p className="text-gray-700 text-base leading-relaxed" data-id="element-100">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}